import { CircuitRelayTransport } from './transport.js';
export function circuitRelayTransport(init = {}) {
    return (components) => {
        return new CircuitRelayTransport(components, init);
    };
}
//# sourceMappingURL=index.js.map